import { BaseModel, Resource, Form, Entry, EntryTypes, CardMode } from '@ngx-resource-toolkit/core';
import { environment } from '../../../environments/environment';
import { LeaResource } from '../../shared/resource/lea.resource';
import { Adresse } from '../../shared/famille/models/famille.model';
import { DisponibiliteModel } from '../../shared/disponibilite/disponibilite.model';
import { DisciplineRelationModel } from '../../parametrage/listes/disciplines/models/discipline.model';
import { CoursModel } from '../../cours/models/cours.model';
import { Validators, FormGroup } from '@angular/forms';
import { ProfesseurReducer, ProfesseurEpics } from './professeur.store';
import { civiliteFetchOptions } from '../../shared/resource/select-options';
import { TABLE } from '../../app.constantes';
import { DateHelper } from '../../shared/helpers/date.helper';
import {ValidationsHelper} from "../../shared/helpers/validations.helper";

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/professeur',
            methods: LeaResource.methods,
        }
    },
    store: {
        namespace: 'professeur',
        reducer: ProfesseurReducer,
        epics: ProfesseurEpics,
    }
})
@Form({
    'create': {
        onChanges: (value: ProfesseurModel, form: FormGroup) => {
            const nom: string = form.value['nom'];
            const heureContratAffichee: string = form.value['heureContratAffichee'];
            if (nom) {
                form.patchValue({nom: nom.toUpperCase()},  {emitEvent: false});
            }
            if (heureContratAffichee) {
                const heureDecimalAvantModif = form.value['heureContrat'];
                const heureDecimalModifiee = DateHelper.horaireToHeureDecimal(heureContratAffichee);

                if (heureDecimalAvantModif != heureDecimalModifiee) {
                    const heureContratAfficheeUppercase = heureContratAffichee.toUpperCase();
                    form.patchValue({heureContratAffichee: heureContratAfficheeUppercase, heureContrat: heureDecimalModifiee });
                }
            }
        }
    },
    'table': {},
})
export class ProfesseurModel extends BaseModel {

    _explicitType: string = 'Professeur';

    @Entry({
        base: {
            hidden: true,
        },
        'table': {
            label: 'N°',
            flexGrow: 1,
        },
        'create': {},
    })
    id: string;

    @Entry({
        base: {
            hidden: true,
            type: EntryTypes.SELECT,
            label: 'Salle',
            // fetchOptions: salleFetchOptions,
            css: {
                group: 'col-xs-6'
            },
            //compareFn: (one, two) => one && two && one.id === two.id,
            //transform: (value, row) => value.nom,
            minWidth: TABLE.MIN_WIDTH.SALLE,
        },
        'table': {},
        'create': {
            hidden: false,
            label: 'Salle',
        },
    })
    salleId: string;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            css: {
                group: 'col-xs-6',
            },
            label: 'Civilité',
            fetchOptions: civiliteFetchOptions,
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    civilite: string;
    civiliteLibelle: string;

    @Entry({
        'create': {
            type: EntryTypes.TEXT,
            placeholder: 'Nom',
            label: 'Nom',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
            validators: [Validators.required],
            validatorsMsgs: {'required': 'Le nom est obligatoire'},
        },
        'table': {
            label: 'Nom',
            flexGrow: 1,
        }
    })
    nom: string;

    @Entry({
        'create': {
            type: EntryTypes.TEXT,
            placeholder: 'Prénom',
            label: 'Prénom',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
        },
        'table': {
            label: 'Prénom',
            flexGrow: 1,
        }
    })
    prenom: string;

    @Entry({
        'table': {
            label: 'Occupation',
            flexGrow: 3,
        }
    })
    occupation: any;

    @Entry({
        'create': {
            type: EntryTypes.DATE,
            format: 'YYYY-MM-DD',
            placeholder: 'JJ/MM/AAAA',
            formatDisplay: 'DD/MM/YYYY',
            label: 'Date naissance',
            css: {
                group: 'col-xs-6',
            },
        }
    })
    dateNaissStr: string;

    @Entry({
        'create': {
            type: EntryTypes.TEXT,
            placeholder: 'Email',
            label: 'Email',
            css:  {
                group: 'col-xs-12',
                input: '',
            },
            validators: [ValidationsHelper.emailRegex()],
            validatorsMsgs: {
                'emailFormat': 'L\'email n\'est pas valide',
            }
        }
    })
    email: string;

    @Entry({
        'create': {
            type: EntryTypes.TEXT,
            placeholder: 'Tél domicile',
            label: 'Tél domicile',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
        }
    })
    telephoneDomicile: string;

    @Entry({
        'create': {
            type: EntryTypes.TEXT,
            placeholder: 'Tél portable',
            label: 'Tél portable',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
        }
    })
    telephonePortable: string;

    @Entry({
        'create': {
            nested: true,
            css: {
                group: 'col-xs-12'
            }
        }
    })
    adresse: Adresse;

    @Entry({
        'create': {
            type: EntryTypes.TEXT,
            placeholder: 'N° SS',
            label: 'N° SS',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
        }
    })
    numSecu: string;

    @Entry({
        'create': {
            type: EntryTypes.TEXT,
            placeholder: 'N° SS Clé',
            label: 'N° SS Clé',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
        }
    })
    numSecuCle: string;

    @Entry({
        base: {
            label: 'Base horaire hebdo',
            type: EntryTypes.TEXT, //TIME, // Ne semble pas prendre en compte le transform
            css: {
                group: 'col-xs-6',
                label: 'col-xs-4 align-left',
                input: 'col-xs-8',
            },
            minWidth: TABLE.MIN_WIDTH.HORAIRE,
            // convertir la valeur decimal en HH et MM pour l'a fficher au format 00H00
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    heureContratAffichee: string;
    @Entry({
        base: {
            hidden: true,
            label: 'Base horaire hebdo (decimal)',
            type: EntryTypes.NUMBER, //TIME, // Ne semble pas prendre en compte le transform
        },
        'create': {},
    })
    heureContrat: number; // Attention, c'est un nombre d'heures decimal => calcul pour obtenir les minutes
    heurePrevue: number; // Nombre d'heures réels de cours (doit être calculé à chaque ajout de cours)

    @Entry({
        base: {
            type: EntryTypes.DATE,
            format: 'x',
            placeholder: 'JJ/MM/AAAA',
            formatDisplay: 'DD/MM/YYYY',
            label: 'Date d\'entrée',
            css: {
                group: 'col-xs-6',
            },
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    dateEntree: string;

    @Entry({
        'create': {
            type: EntryTypes.DATE,
            format: 'YYYY-MM-DD',
            placeholder: 'JJ/MM/AAAA',
            formatDisplay: 'DD/MM/YYYY',
            label: 'Date de sortie',
            css: {
                group: 'col-xs-6',
            },
        }
    })
    dateFin: string; // Date de fin = indique que la personne quitté l'école à cette date

    @Entry({
        'create': {
            type: EntryTypes.TEXTAREA,
            css: {
                group: 'col-lg-12 col-xs-12',
            },
            label: 'Saisie libre'
        }
    })
    saisieLibre: string;

    @Entry({
        'create': {
            type: EntryTypes.CARDS,
            mode: CardMode.EDIT,
            model: DisciplineRelationModel,
            title: 'Discipline',
            addLabel: 'Ajouter une discipline',
            css: {
                box: 'panel panel-default col-xs-6 col-md-4 col-lg-3',
            },
            multiple: true,
        }
    })
    disciplines: DisciplineRelationModel[]; // DisciplineSelectModel[];

    @Entry({
        'create': {
            type: EntryTypes.CARDS,
            mode: CardMode.EDIT,
            model: DisponibiliteModel,
            addLabel: 'Ajouter une disponibilité',
            title: 'Disponibilité',
            css: {
                box: 'panel panel-default col-xs-6 col-md-4 col-lg-3',
            },
            multiple: true,
        }
    })
    disponibilites: DisponibiliteModel[];

    cours: CoursModel[];

	disciplinesTxt: string; // Liste des disciplines dans un champ texte séparées par des ","


    constructor(data?) {
        super();
        if (!data) data = {};
        Object.assign(this, data);

        this.heureContratAffichee = DateHelper.decimalHoursToHoursMin(data.heureContrat);

        this.civilite = data.civilite;

        this.adresse = new Adresse(data.adresse);

        this.disponibilites = data.disponibilites ? data.disponibilites.map((dispo) => {
            return new DisponibiliteModel(dispo);
        }) : [];
        this.disciplines = data.disciplines ? data.disciplines.map((discipline) => {
            console.log('mapping discipline', discipline);
            // return new DisciplineSelectModel(discipline.discipline);
            return new DisciplineRelationModel(discipline);
        }) : [];

        this.cours = data.cours ? data.cours.map((cours) => {
            return new CoursModel(cours);
        }) : [];
    }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/professeur/models/professeur.model.ts